import ProductItem from './product_item';
import Carousel from '../shared/carousel';
import Container from '../shared/container';

const ProductSection = ({
  fields: { productIds, backgroundColor },
  productReference = '{}',
  perPage = 4,
  ...rest
}) => {
  // Get full product information based on list of IDs
  const parsedProductReference = JSON.parse(productReference);

  const productList =
    Object.keys(parsedProductReference).length && productIds !== undefined
      ? productIds.reduce((acc, id) => {
          if (parsedProductReference[id] !== undefined) {
            acc.push(parsedProductReference[id]);
          }
          return acc;
        }, [])
      : [];

  return (
    productList.length > 0 && (
      <Container backgroundColor={backgroundColor} isFullWidth {...rest}>
        <Carousel
          slides={productList.map(product => ({
            content: <ProductItem {...product} />,
            key: product.url,
          }))}
          columns={perPage}
        />
      </Container>
    )
  );
};

export default ProductSection;
